<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>

<div class="dialog-container">
  <div class="cancel-icon">
    <button mat-icon-button (click)="onCancelClick()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <header class="dialog-header">
    <h1 mat-dialog-title>
      {{langObj ? langObj?.ScheduleTasks : ('ScheduleTasks' | translate)}}
    </h1>

    <!-- Technician Select with Search -->
    <mat-form-field class="w-64" style="margin-right: 10px;">
      <mat-label>{{langObj ? langObj?.SelectTechnician : ('SelectTechnician' | translate)}}</mat-label>
      <mat-select multiple [(ngModel)]="selectedTechnicians" (openedChange)="onDropdownOpened()"
        (selectionChange)="onTechniciansSelected($event.value)">
        <input [(ngModel)]="technicianSearch" (keyup)="searchValues($event)" class="form-control w-100"
          placeholder="Search Technician">

        <mat-option *ngFor="let technician of filteredTechnicianList" [value]="technician.employeeCode">
          {{ technician.fullName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-22">
      <mat-label>{{langObj ? langObj?.FromTaskDate : ('FromTaskDate' | translate)}}</mat-label>
      <input matInput [min]="minDate" [matDatepicker]="picker" [(ngModel)]="FromTaskDate"
        (ngModelChange)="onFromTaskDateChange()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{langObj ? langObj?.ToTaskDate : ('ToTaskDate' | translate)}}</mat-label>
      <input matInput [min]="toTaskMinDate" [matDatepicker]="picker2" [(ngModel)]="ToTaskDate"
        (ngModelChange)="onToTaskDateChange()">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </header>


  <div mat-dialog-content class="dialog-content">

    <!-- AG Grid -->
    <ag-grid-angular style="width: 100%; height: 400px;" class="ag-theme-alpine" [rowData]="rowData"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button class="dialog-cancel-btn" (click)="onCancelClick()">Cancel</button>
    <button mat-button class="dialog-save-btn transition-opacity duration-200" (click)="onSaveClick()"
      [disabled]="isRescheduleDisabled" [ngClass]="{ 'opacity-50 cursor-not-allowed': isRescheduleDisabled }"
      cdkFocusInitial>
      Schedule
    </button>
  </div>
</div>